<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="golfGroupTbody"
            hide-default-footer
            disable-pagination
            :height="700"
        >
            <template v-slot:[`item.Btn`]="{ item }">
                <v-btn
                    color="green darken-4"
                    text
                    @click="editModal(item)"
                    :disabled="btn[3].isActive"
                    v-if="item.template !== null"
                    class="editBtn">変更</v-btn>
                <v-btn
                    color="green darken-4"
                    text
                    :disabled="btn[2].isActive"
                    @click="addModalView(item)"
                    v-if="item.template === null"
                    class="addBtn">追加</v-btn>
            </template>
        </v-data-table>
        <TemplateModal ref="Modal" :edit-data="findData" @refresh-event="getTemplateMaster"></TemplateModal>
    </div>
</template>

<script>
import TemplateModal from './modal/TemplateModal';
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import { GET_TEMPLATE_LIST } from '@/constants/master';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        TemplateModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            // v-data-tableのヘッダー
            headers: [
                { text: 'コード', value: 'code', align: 'center', sortable: false },
                { text: '内容', value: 'code_name', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0010'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getTemplateMaster();
        },
        /** ----------------------------------------------
        * テンプレートを取得
        * ---------------------------------------------- */
        async getTemplateMaster () {
            this.desserts = await this.$apollo.mutate({
                mutation: GET_TEMPLATE_LIST
            }).then(res => {
                return res.data.getTemplateMaster;
            }).catch(error => { this.error = error; });
        },
        /** ----------------------------------------------
        * 追加ボタン押下時の処理
        * 子コンポーネントのmodalをtrueにして表示する
        * ---------------------------------------------- */
        addModalView (item) {
            this.findData = this.desserts.find(ele => ele.code === item.code);
            this.$refs.Modal.addModal();
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/GolfCourseModal.vue'
        * -------------------------------------------- */
        editModal (item) {
            this.findData = this.desserts.find(ele => ele.code === item.code);
            this.$refs.Modal.editModal();
        }
    }
};
</script>

<style scoped>
    .golfGroupTable ::v-deep td{
        font-size: 11px;
    }
    .golfGroupTable ::v-deep i{
        font-size: 15px;
    }
    .golfGroupTbody {
        display: block;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .golfGroupTbody ::v-deep i {
        font-size: 17px;
    }

    .v-input__control{
        flex-direction: column; /* 子要素をflexboxにより縦方向に揃える */
        justify-content: center; /* 子要素をflexboxにより中央に配置する */
        align-items: center;  /* 子要素をflexboxにより中央に配置する */
    }

    .form-wrap{
        display: flex;
        flex-wrap:nowrap;
    }

    .addBtn {
        background: Transparent;
        text-decoration: underline;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }
</style>
